import { Product } from '@model/product';

export const getDiscount = (product: Product) => product.promotionResults?.find((item) => item.orderTotalCode === 'ot_df_product_discount')?.value
